/**
 * Sleek "Vaulted" block — takes the FMV's slot once the player keeps the
 * card (partner feedback 2026-09-30): a muted "Vaulted" in the FMV's font and
 * svh-capped size, so the swap doesn't move the CTA below it, over a caption
 * in the FMV label's knobs (partner Figma 2026-10-06).
 */
export function VaultedLine() {
  return (
    <div className="flex flex-col items-center">
      <span
        data-co-component="RevealVaultedLine"
        className="inline-block font-semibold tracking-[0.37px]"
        style={{
          color: 'var(--co-RevealVaultedLine-color, #6D707C)',
          fontFamily: 'var(--co-WinnerStepProfit-font, "Inter"), Inter, sans-serif',
          fontSize: 'min(var(--co-WinnerStepProfit-size, 44px), 6.3svh)',
          lineHeight: 1.27,
        }}
      >
        Vaulted
      </span>
      <span
        data-co-component="WinnerStepFMV"
        style={{
          color: 'var(--co-WinnerStepFMV-color, #6D707C)',
          fontFamily: 'var(--co-WinnerStepFMV-font, "Inter"), Inter, sans-serif',
          fontSize: 'var(--co-WinnerStepFMV-size, 14px)',
          lineHeight: '20px',
          letterSpacing: '-0.15px',
        }}
      >
        Card has been added to your vault
      </span>
    </div>
  );
}
